export default function omit<T extends Record<string, unknown>, K extends [...(keyof T)[]]>(source: T, ...toExclude: K) {
    return Object.keys(source)
        .filter((key) => !toExclude.includes(key))
        .reduce<{ [K2 in Exclude<keyof T, K[number]>]: T[K2] }>((acc, curr) => {
            return { ...acc, [curr]: source[curr] }
        }, {} as { [K in keyof typeof source]: typeof source[K] })
}
